module.exports = __webpack_public_path__ + "static/media/Rex Orange County - Sunflower.5f857705.mp3";